import { defineStore } from 'pinia';

import {
  WalletUserDetailResponse,
  WalletUserRepository,
} from '@/repositories/generated';
import { WalletUserValidationEditForm } from '@/validations/wallet-user';

type TEditWalletUserState = {
  form: WalletUserValidationEditForm | undefined;
  initData: WalletUserDetailResponse | undefined;
};

export const useEditWalletUserStore = defineStore('editWalletUser', {
  state: (): TEditWalletUserState => ({
    form: undefined,
    initData: undefined,
  }),
  actions: {
    async editWalletUser() {
      const {
        form,
        initData,
      } = this;

      if (!(form && initData)) return;

      await WalletUserRepository.edit({
        id: initData.walletUserId,
        requestBody: {
          balanceNotice: form.balanceNotice === 'ON',
          birthday: form.birthday ?? undefined,
          chargeNotice: form.chargeNotice === 'ON',
          email: form.email || undefined, // 空文字の場合にundefinedにしたいため||を使用
          externalUserId: form.externalUserId || undefined, // 空文字の場合にundefinedにしたいため||を使用
          firstName: form.firstName ?? undefined,
          firstNameKana: form.firstNameKana ?? undefined,
          lastName: form.lastName ?? undefined,
          lastNameKana: form.lastNameKana ?? undefined,
          loginLockNotice: form.loginLockNotice === 'ON',
          maxChargeAmount: form.maxChargeSettings?.maxChargeAmount,
          maxChargeAmountPerDay: form.maxChargeSettings?.maxChargeAmountPerDay,
          maxChargeAmountPerMonth: form.maxChargeSettings?.maxChargeAmountPerMonth,
          maxSettlementAmount: form.maxSettlementAmount ?? 0,
          maxSettlementAmountPerDay: form.maxSettlementAmountPerDay ?? 0,
          maxSettlementAmountPerMonth: form.maxSettlementAmountPerMonth ?? 0,
          phone: form.phone || undefined, // 空文字の場合にundefinedにしたいため||を使用
          remarks: form.remarks,
          settlementNotice: form.settlementNotice === 'ON',
          sex: form.sex === 'UNSPECIFIED' ? undefined : form.sex,
          lastUpdatedAt: initData.updatedAt,
        },
      });
    },
    async setInitData(id: string) {
      this.$reset();

      const response = await WalletUserRepository.detail({ id });
      this.initData = response;
    },
    setUiForm(form: WalletUserValidationEditForm) {
      const createForm = (_form: WalletUserValidationEditForm) => ({
        ..._form,
      });
      this.form = createForm(form);
    },
    $resetForm() {
      this.form = undefined;
    },
  },
});
